var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 504.09,
    height: 407.17,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504.09 407.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 241.13,
    y1: 391.18,
    x2: 479.97,
    y2: 391.18,
    gradientTransform: "translate(751.73 30.63) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b6218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b19636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b6218"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -35.31,
    y1: 291.44,
    x2: 425.61,
    y2: 150.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3c651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7b6218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfb23a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 344.81,
    y: 271.76,
    width: 31.47,
    height: 238.84,
    transform: "translate(-30.63 751.73) rotate(-90)",
    fill: "url(#b)",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m466.97,406.9l37.11.27L274.22,30.46,255.89,0l-96.64,158.38c-5.53-.79-11.19-1.21-16.94-1.21H31.47V0H0v157.16h0c0,10.49,0,20.98,0,31.47h0v99.79h31.47s85.25,0,85.25,0v-.03l.04.03,57.22-93.76c32.26,12.69,55.1,44.1,55.1,80.87v12.96c0,48.03-38.93,86.96-86.96,86.96H0v31.47c47.32,0,94.64,0,141.96,0h.04c65.48,0,118.57-53.09,118.57-118.58v-12.93c0-48.1-28.73-89.5-69.96-107.97l65.17-106.78,211.19,346.23ZM99.1,256.95H31.47v-68.32h109.32l-41.69,68.32Z",
    fill: "url(#c)",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGold);
export default __webpack_public_path__ + "static/media/logo-gold.d2ee9df4d5082432a2fab1d20f8d960d.svg";
export { ForwardRef as ReactComponent };